import { c as _c } from "react/compiler-runtime";
import { Slide, type SlideProps } from '@mui/material';
import { forwardRef } from 'react';
export const SlideUpTransition = forwardRef(function Transition(props, ref) {
  const $ = _c(3);
  let t0;
  if ($[0] !== props || $[1] !== ref) {
    t0 = <Slide direction="up" ref={ref} {...props} />;
    $[0] = props;
    $[1] = ref;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
});